import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { withStyles } from 'tss-react/mui';
import PropTypes from 'prop-types';
import { reactLocalStorage } from 'reactjs-localstorage';

const styles = () => ({
  dialogContentWithNewLines: {
    whiteSpace: 'pre-wrap',
  },
});

function FormDialog(props) {
  const {
    buttonTitle,
    dialogTitle,
    contentText,
    contentFields,
    actions,
    handleClickOpen,
    handleClose,
    open,
    variant,
    buttonClassName,
    disabled,
    fullWidth,
    maxWidth,
    classes,
    dialogType,
  } = props;

  return (
    <div onClick={(e) => e.stopPropagation()}>
      <Button
        disabled={disabled}
        className={buttonClassName}
        color="primary"
        onClick={(e) => {
          e.stopPropagation();
          handleClickOpen();
        }}
        variant={variant}
      >
        {buttonTitle}
      </Button>
      <Dialog
        fullWidth={fullWidth}
        maxWidth={maxWidth}
        open={open}
        onClose={(e, reason) => {
          if (reason === 'backdropClick') {
            reactLocalStorage.set(dialogType, false);
          }
          handleClose();
        }}
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title">{dialogTitle}</DialogTitle>
        <DialogContent>
          <DialogContentText className={classes.dialogContentWithNewLines}>
            {contentText}
          </DialogContentText>
          {contentFields}
        </DialogContent>
        <DialogActions>{actions}</DialogActions>
      </Dialog>
    </div>
  );
}

FormDialog.propTypes = {
  buttonTitle: PropTypes.string.isRequired,
  dialogTitle: PropTypes.string.isRequired,
  contentText: PropTypes.string.isRequired,
  contentFields: PropTypes.object,
  actions: PropTypes.object.isRequired,
  handleClickOpen: PropTypes.func.isRequired,
  handleClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  dialogType: PropTypes.string.isRequired,
  buttonClassName: PropTypes.string,
  className: PropTypes.string,
  variant: PropTypes.string,
  disabled: PropTypes.bool,
  fullWidth: PropTypes.bool,
  maxWidth: PropTypes.string,
};

export default withStyles(FormDialog, styles);
